<template>
  <div class="nfc-tags">
    <div class="header">
      <h3>NFC tags</h3>
      <el-button
        v-if="!loading"
        size="mini"
        icon="el-icon-plus"
        @click="openAdd">
        Add tag
      </el-button>
    </div>

    <div class="loading" v-if="loading">
      <i class="el-icon-loading"></i>
    </div>

    <div class="load-error" v-else-if="loadError">
      <p>Could not load NFC tags</p>
      <el-button size="mini" @click="fetchTags">Retry</el-button>
    </div>

    <div class="empty" v-else-if="tags.length === 0">
      <p>No NFC tags</p>
    </div>

    <div class="rows" v-else>
      <nfc-tag-row
        v-for="tag in tags"
        :key="tag.id"
        :tag="tag"
        @rename="openRename"
        @remove="handleRemove" />
    </div>

    <el-dialog
      :append-to-body="true"
      width="400px"
      :title="upsertTarget ? 'Rename NFC tag' : 'Add NFC tag'"
      :visible.sync="showUpsertDialog">
        <upsert-form
          v-if="showUpsertDialog"
          :userId="userId"
          :tag="upsertTarget"
          @created="handleCreated"
          @updated="handleUpdated"
          @close="showUpsertDialog = false" />
    </el-dialog>
  </div>
</template>

<script>
import NfcTagRow from './NfcTagRow'
import UpsertForm from './UpsertForm'

export default {
  name: 'NfcTags',
  components: { NfcTagRow, UpsertForm },
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      tags: [],
      loading: true,
      loadError: null,
      showUpsertDialog: false,
      upsertTarget: null
    }
  },
  methods: {
    async fetchTags () {
      this.loading = true
      this.loadError = null
      try {
        const response = await this.$http.get(this.$api.user(this.userId).nfcTags.index)
        this.tags = response.data
      } catch (e) {
        this.loadError = e
      } finally {
        this.loading = false
      }
    },
    openAdd () {
      this.upsertTarget = null
      this.showUpsertDialog = true
    },
    openRename (tag) {
      this.upsertTarget = tag
      this.showUpsertDialog = true
    },
    handleCreated (tag) {
      this.tags.push(tag)
      this.showUpsertDialog = false
      this.$message.success('Tag added')
    },
    handleUpdated (tag) {
      const index = this.tags.findIndex(t => t.id === tag.id)
      if (index !== -1) this.$set(this.tags, index, tag)
      this.showUpsertDialog = false
      this.$message.success('Tag renamed')
    },
    async handleRemove (tagId) {
      try {
        await this.$http.delete(this.$api.user(this.userId).nfcTags.one(tagId))
        const index = this.tags.findIndex(t => t.id === tagId)
        if (index !== -1) this.tags.splice(index, 1)
        this.$message.success('Tag removed')
      } catch (e) {
        this.$message.error('Could not remove tag')
      }
    }
  },
  created () {
    this.fetchTags()
  }
}
</script>

<style lang="scss" scoped>
  .nfc-tags {
    display: flex;
    flex-direction: column;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 40px 10px 40px;

    h3 {
      margin: 0;
      font-size: 13px;
      color: $text-light;
      font-weight: 600;
    }
  }

  .loading,
  .empty,
  .load-error {
    padding: 30px;
    text-align: center;
    color: $text-light;
    font-size: 13px;

    p {
      margin: 0 0 10px 0;
    }

    .el-icon-loading {
      font-size: 22px;
    }
  }

  .rows {
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/user/nfc-tags/NfcTags.vue